<template>
    <div class="filter-entry">
        <div class="filter-label">
            {{ name }}
        </div>
        <input class="form-control filter-number" v-model="data[id + '_from']"></input> - <input class="form-control filter-number" v-model="data[id + '_to']"></input>
    </div>
</template>

<script>
    export default {
        props: [
            'name',
            'id',
            'data'
        ],
        data() {
            return {
            };
        }
    }
</script>